module.exports = __webpack_public_path__ + "static/media/pink-circle.85efadd3.png";